<template>
  <v-container>
    <DesktopTopPart />
    <v-row>
      <v-col class="white px-0">
        <v-container fluid>
          <v-row>
            <v-col
              v-if="!progressOpening && !showBookNowForm"
              cols="12"
              class="px-0"
            >
              <ObjectImages
                v-if="selectedObject"
                :images="sortedObjectImages(selectedObject.objectImages)"
                :compact="isMobileView"
                :wide="true"
                :rooms="selectedObject.objectRooms"
                :img-folder="'objectImages/large'"
              />
            </v-col>
            <v-col class="grow pl-0 pt-0">
              <MyLoader
                v-if="!selectedObject || !selectedObject._id"
                :style="{
                  marginTop: '150px',
                }"
              />
              <ObjectInfo
                v-if="!showBookNowForm && selectedObject && selectedObject._id"
                :object="selectedObject"
              />
              <BookingForm
                v-if="showBookNowForm && selectedObject && selectedObject._id"
                :object="selectedObject"
              />

              <MyLoader v-if="$store.state.progressSearching" />
              <!-- List v-else / -->
            </v-col>
            <ObjectRightSidebar />
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-if="!showBookNowForm">
      <PageFooter />
    </v-row>
  </v-container>
</template>

<script>
import MyLoader from '@/components/App/_MyLoader'
import DesktopTopPart from '@/components/Views/Layout/DesktopTopPart'
import ObjectRightSidebar from '@/components/Views/Object/ObjectRightSidebar'
import sharedComputed from '@/methods/sharedComputed'
import ObjectInfo from '@/components/Object/ObjectInfo'
import BookingForm from '@/components/Forms/BookingForm'

import state from '@/store/state'
import { createHelpers } from 'vuex-map-fields'
import PageFooter from '@/components/App/_PageFooter'
import ObjectImages from '@/components/ObjectImages/ObjectImages'
import objectMethods from '@/methods/objectMethods'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectPageDesktop',

  components: {
    ObjectImages,
    PageFooter,
    BookingForm,
    ObjectInfo,
    ObjectRightSidebar,
    DesktopTopPart,
    MyLoader,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
  },

  methods: {
    ...objectMethods,
  },
}
</script>
